import type { CmsTheme } from "@/lib/cms/cms-theme.constants";
import { createContext, useContext } from "react";

/**
 * Contexte fournissant le thème CMS (palette + défauts) aux custom fields Puck
 * de l'apparence par page. Les custom fields (`type: "custom"`) sont rendus par
 * Puck HORS de l'arbre React de la page d'édition ; on ne peut donc PAS leur
 * passer le thème par closure de la config (la config est un singleton statique).
 *
 * Solution : un Provider monté autour de `<Puck>` dans l'éditeur, lu par les
 * custom fields via `usePuckTheme()`. Le thème vient de `useGetCmsTheme()`
 * (GET /back/api/cms/theme), donc identique à celui de l'ancien CMS — aucune
 * source de vérité dupliquée, aucune API/migration ajoutée.
 */
const PuckThemeContext = createContext<CmsTheme | null>(null);

export function PuckThemeProvider({
  theme,
  children,
}: {
  theme: CmsTheme | null;
  children: React.ReactNode;
}) {
  return (
    <PuckThemeContext.Provider value={theme}>
      {children}
    </PuckThemeContext.Provider>
  );
}

/** Thème CMS courant pour les custom fields d'apparence (null tant que non chargé). */
export function usePuckTheme(): CmsTheme | null {
  return useContext(PuckThemeContext);
}
